import customSelect from 'custom-select';

const customSelectInstances = [];

if (jQuery('select').length) {
  document.querySelectorAll('select').forEach((item) => {
    const select = item;
    const queryString = window.location.search;
    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      const termIndustry = urlParams.get('industry');
      const termFunction = urlParams.get('function');
      const selectId = select.id;
      if (selectId === 'job_function') {
        let flag = false;
        jQuery(`#${selectId}`).find('option').each(function handleOption() {
          if (jQuery(this).val() === termFunction) {
            flag = true;
          }
        });
        if (flag) {
          jQuery(`#${selectId}`).val(termFunction);
          jQuery('.job-board__table-tbody.list .job-board__table-row').each(function handleJobBoardTableFunction() {
            const tableRowItem = jQuery(this);
            if (tableRowItem.hasClass(termFunction)) {
              tableRowItem.show();
            } else {
              tableRowItem.hide();
            }
          });
        }
      } else if (selectId === 'job_industry') {
        let flag = false;
        jQuery(`#${selectId}`).find('option').each(function handleTermIndustryFlag() {
          if (jQuery(this).val() === termIndustry) {
            flag = true;
          }
        });
        if (flag) {
          jQuery(`#${selectId}`).val(termIndustry);
          jQuery('.job-board__table-tbody.list .job-board__table-row').each(function handleJobBoardTableIndustry() {
            const tableRowItem = jQuery(this);
            if (tableRowItem.hasClass(termIndustry)) {
              tableRowItem.show();
            } else {
              tableRowItem.hide();
            }
          });
        }
      }
    }
    customSelectInstances.push(...customSelect(select));
  });
}

export {
  // eslint-disable-next-line import/prefer-default-export
  customSelectInstances,
};
